// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ba3c7872","338":"05eb99b4","845":"ad00b7e4"}[chunkId] + ".chunk.js";
};